// referralSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  code: null,
  refCode: null,
  refLoginCompleteToken: false
};

const referralSlice = createSlice({
  name: 'referral',
  initialState,
  reducers: {
    setReferral: (state, action) => {
      state.code = action.payload;
    },
    setCodeRef: (state, action) => {
      state.refCode = action.payload;
    },
    setRefloginComplete: (state, action) => {
      state.refLoginCompleteToken = action.payload;
    },
    clearReferral: (state) => {
      state.refCode = null;
      state.code = null;
    },
  },
});

export const selectReferralCode = (state) => state.referralReducer.code;
export const selectRefCode = (state) => state.referralReducer.refCode;
export const selectRefLoginCompleteToken = (state) => state.referralReducer.refLoginCompleteToken;

export const { setReferral, setCodeRef, setRefloginComplete,  clearReferral} = referralSlice.actions;
export default referralSlice.reducer;
